import React from "react";
import Slider from "react-slick";
import "./ProductBundleComp.scss";
import { OfferTagBtnIcon } from "../../../utils/SvgComps";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
const ProductBundleComp = (props) => {
  const { bundles, priceInfo, bannerAction, bannerURL, isCart } = props;
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  let navigate = useNavigate();
  return (
    <>
      <div className="combo-product">
        <div className="comb-combne-tag">
          <div className="combo-tag-b2c">
            <svg
              width="85"
              height="53"
              viewBox="0 0 85 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.7179 29.0213L20.7179 48.628L0.799977 48.628L6.64545 38.8246L0.799978 29.0213L20.7179 29.0213Z"
                fill="#FFC21D"
              ></path>
              <path
                d="M64.2883 29.0213L64.2883 48.628L84.2062 48.628L78.3607 38.8246L84.2062 29.0213L64.2883 29.0213Z"
                fill="#FFC21D"
              ></path>
              <path
                d="M15.116 34.312L20.7179 29.0213V52.985H15.116V34.312Z"
                fill="#9C7918"
              ></path>
              <path
                d="M69.8901 34.6232L64.2882 29.0213V52.985H69.8901V34.6232Z"
                fill="#9C7918"
              ></path>
              <path
                d="M41.1304 1.26479C41.7822 0.704997 42.7451 0.704998 43.397 1.26479L46.793 4.1814C47.2995 4.61634 47.9825 4.78469 48.6331 4.63492L52.9955 3.63063C53.8328 3.43787 54.6855 3.88536 55.0025 4.68395L56.6541 8.84471C56.9004 9.46518 57.427 9.93166 58.0726 10.1014L62.4021 11.2395C63.2331 11.4579 63.7801 12.2504 63.6897 13.1048L63.2185 17.5565C63.1483 18.2204 63.3977 18.8781 63.8905 19.3285L67.1952 22.3482C67.8295 22.9278 67.9456 23.8837 67.4684 24.5982L64.9824 28.3211C64.6117 28.8763 64.5269 29.5746 64.754 30.2024L66.2768 34.412C66.5691 35.22 66.2277 36.1203 65.4731 36.5313L61.5418 38.6724C60.9555 38.9917 60.5559 39.5706 60.4652 40.232L59.8573 44.6671C59.7406 45.5184 59.0199 46.1569 58.1608 46.1701L53.6847 46.239C53.0172 46.2493 52.3943 46.5762 52.0067 47.1197L49.4073 50.7643C48.9084 51.4638 47.9735 51.6943 47.2066 51.3067L43.2112 49.2876C42.6154 48.9865 41.912 48.9865 41.3162 49.2876L37.3208 51.3067C36.5539 51.6943 35.619 51.4638 35.1201 50.7643L32.5207 47.1197C32.1331 46.5762 31.5102 46.2493 30.8427 46.239L26.3666 46.1701C25.5075 46.1569 24.7868 45.5184 24.6701 44.6671L24.0622 40.232C23.9715 39.5706 23.5719 38.9917 22.9856 38.6724L19.0543 36.5313C18.2997 36.1203 17.9583 35.22 18.2506 34.412L19.7734 30.2024C20.0005 29.5746 19.9157 28.8763 19.5449 28.3211L17.059 24.5982C16.5818 23.8837 16.6979 22.9278 17.3322 22.3482L20.6368 19.3285C21.1297 18.8781 21.3791 18.2204 21.3089 17.5565L20.8377 13.1048C20.7473 12.2504 21.2943 11.4579 22.1253 11.2395L26.4548 10.1014C27.1004 9.93166 27.627 9.46518 27.8733 8.84471L29.5249 4.68395C29.8419 3.88535 30.6945 3.43787 31.5319 3.63063L35.8943 4.63492C36.5449 4.78469 37.2279 4.61634 37.7343 4.1814L41.1304 1.26479Z"
                fill="#FFBA00"
                stroke="#665000"
                strokeWidth="0.361369"
              ></path>

              <rect
                x="15.116"
                y="34.6232"
                width="54.7742"
                height="18.3618"
                fill="#FFBA00"
              ></rect>
              <defs>
                <linearGradient
                  id="paint0_linear_1420_799"
                  x1="42.2637"
                  y1="0.0533447"
                  x2="42.2637"
                  y2="52.9808"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFE175"></stop>
                  <stop offset="1" stop-color="#FFD12E"></stop>
                </linearGradient>
              </defs>
            </svg>
            <span class="tag-data-combo">
              <span>{bundles?.length}</span>
              <span>Items</span>
              <strong>COMBO</strong>
            </span>
          </div>
          { !_.isEmpty(priceInfo) &&
            priceInfo?.isOffer&&<div className="offer-with-combo">
            <OfferTagBtnIcon />
          </div>}
        </div>
        {bundles?.length>0?<Slider {...settings}>
          {bundles?.map((item, index) => {
            return (
              <>
              <div className="card-img-section product-img-sec">
              <img
                className="cardthum cursor-pointer"
                src={item.thumbnail}
                alt={"title"}
                onClick={isCart ? () => navigate(bannerAction) : bannerAction}
                loading="lazy"
              />
              </div>
              </>
            );
          })}
        </Slider>: <div className="card-img-section product-img-sec"><img
        className="cardthum"
        src={bannerURL}
        alt={"title"}
        onClick={isCart ? () => navigate(bannerAction) : bannerAction}
        loading="lazy"
      /></div>}
      </div>
    </>
  );
};
export default ProductBundleComp;
